<template>
  <div class="box7">
    <div class="con-bg">
      <pageTitle
        title="学员活动" 
        text="项目将定期举办各类线上线下学员活动，以满足在读学员<br/>行业信息交流、资源共享或人脉圈层搭建拓展的需求" />
      <div class="pic-box">
        <img class="pic" src="../../../assets/coursePage/hawai/box7/left.png" />
        <img class="pic" src="../../../assets/coursePage/hawai/box7/right.png" />
      </div>
    </div>
    <img class="bg" src="../../../assets/coursePage/hawai/box7/erCode.png" alt="">
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box7 {
  background: #fff;
  width: 100%;
  /deep/.course-title-box{
    .course-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #FFFFFF;
      line-height: 64px;
    }
    .course-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #FFFFFF;
      line-height: 40px;
    }
  } 
  .con-bg {
    box-sizing: border-box;
    padding-top: 80px;
    position: relative;
    width: 100%;
    height: 892px;
    background: url("../../../assets/coursePage/hawai/box7/bg.png") no-repeat;
    background-size: 100% 100%;
    .pic-box {
      position: absolute;
      top: 294px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 674px;
      .pic {
        display: block;
        width: 674px;
      }
      .pic:last-child {
        margin-top: 20px;
      }
    }
  }
  .bg {
    margin-top: 160px;
    width: 100%;
    height: 706px;
    display: block;
  }
}
</style>
